export * from "./delegate.js";
export { default } from "./delegate.js";
export { default as oneEvent } from "./one-event.js";
